<div class="flex flex-col h-full">
	<div class="flex-grow p-4 flex items-center justify-center overflow-auto">
		<img
			[src]="logoFile.url"
			alt="Business Logo"
			class="max-w-full max-h-full object-contain aspect-square"
		/>
	</div>
</div>
